const ErrorTx = () => (
  <svg xmlns='http://www.w3.org/2000/svg' fill='none' viewBox='0 0 24 24'>
    <path fill='#FF3218' fillOpacity='0.2' d='M2.667 2.667h18.776v18.56H2.667V2.668Z' />
    <path
      fill='#FF3218'
      fillRule='evenodd'
      d='M6 6h1.714v1.714H6V6Zm1.714 1.714h1.714V9.43H7.714V7.714Zm0 8.572H6V18h1.714v-1.714Zm8.572 0H18V18h-1.714v-1.714Zm-5.143-6.857H9.429v1.714h1.714V9.429Zm0 1.714h1.714v1.714h-1.714v-1.714Zm3.428 1.714h-1.714v1.715h1.714v-1.715Zm0 1.715h1.714v1.714h-1.714V14.57Zm0-6.858h1.715V9.43H14.57V7.714ZM18 6h-1.715v1.714H18V6Zm-5.143 3.429h1.714v1.714h-1.714V9.429Zm-1.714 3.428H9.428v1.715h1.715v-1.715Zm-3.429 1.715H9.43v1.714H7.714V14.57Z'
      clipRule='evenodd'
    />
    <path
      fill='#FF3218'
      d='M5.333 0h13.334v2.667H5.333V0Zm0 21.333h13.334V24H5.333v-2.667Zm16-16H24v13.334h-2.667V5.333ZM0 5.333h2.667v13.334H0V5.333Zm21.333-2.666h-2.666v2.666h2.666V2.667Zm-16 0H2.667v2.666h2.666V2.667Zm0 16H2.667v2.666h2.666v-2.666Z'
    />
    <path fill='#FF3218' d='M21.333 18.667h-2.666v2.666h2.666v-2.666Z' />
  </svg>
)

export { ErrorTx }
